import applyManage from '../../Apply/models/index';

export default applyManage;
